export const allCountries = [
    {
        "code": "AF",
        "name_bg": "Афганистан",
        "name_en": "Afghanistan",
        "currency_en": "Afghan Afghani",
        "currency_bg": "Афганистански афгани",
        "currency_code": "AFN",
        "currency_code_bg": "АФН",
        "phone_code": "93"
    },
    {
        "code": "AL",
        "name_bg": "Албания",
        "name_en": "Albania",
        "currency_en": "Albanian Lek",
        "currency_bg": "Албански лек",
        "currency_code": "ALL",
        "currency_code_bg": "АЛЛ",
        "phone_code": "355"
    },
    {
        "code": "DZ",
        "name_bg": "Алжир",
        "name_en": "Algeria",
        "currency_en": "Algerian Dinar",
        "currency_bg": "Алжирски динар",
        "currency_code": "DZD",
        "currency_code_bg": "ДЗД",
        "phone_code": "213"
    },
    {
        "code": "AD",
        "name_bg": "Андора",
        "name_en": "Andorra",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "376"
    },
    {
        "code": "AO",
        "name_bg": "Ангола",
        "name_en": "Angola",
        "currency_en": "Angolan Kwanza",
        "currency_bg": "Анголска кванза",
        "currency_code": "AOA",
        "currency_code_bg": "АОА",
        "phone_code": "244"
    },
    {
        "code": "AG",
        "name_bg": "Антигуа и Барбуда",
        "name_en": "Antigua and Barbuda",
        "currency_en": "East Caribbean Dollar",
        "currency_bg": "Източнокарибски долар",
        "currency_code": "XCD",
        "currency_code_bg": "ХКД",
        "phone_code": "1268"
    },
    {
        "code": "AR",
        "name_bg": "Аржентина",
        "name_en": "Argentina",
        "currency_en": "Argentine Peso",
        "currency_bg": "Аржентинско песо",
        "currency_code": "ARS",
        "currency_code_bg": "АРС",
        "phone_code": "54"
    },
    {
        "code": "AM",
        "name_bg": "Армения",
        "name_en": "Armenia",
        "currency_en": "Armenian Dram",
        "currency_bg": "Арменски драм",
        "currency_code": "AMD",
        "currency_code_bg": "АМД",
        "phone_code": "374"
    },
    {
        "code": "AU",
        "name_bg": "Австралия",
        "name_en": "Australia",
        "currency_en": "Australian Dollar",
        "currency_bg": "Австралийски долар",
        "currency_code": "AUD",
        "currency_code_bg": "АУД",
        "phone_code": "61"
    },
    {
        "code": "AT",
        "name_bg": "Австрия",
        "name_en": "Austria",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "43"
    },
    {
        "code": "AZ",
        "name_bg": "Азербайджан",
        "name_en": "Azerbaijan",
        "currency_en": "Azerbaijani Manat",
        "currency_bg": "Азербайджански манат",
        "currency_code": "AZN",
        "currency_code_bg": "АЗН",
        "phone_code": "994"
    },
    {
        "code": "BS",
        "name_bg": "Бахами",
        "name_en": "Bahamas",
        "currency_en": "Bahamian Dollar",
        "currency_bg": "Бахамски долар",
        "currency_code": "BSD",
        "currency_code_bg": "БСД",
        "phone_code": "1242"
    },
    {
        "code": "BH",
        "name_bg": "Бахрейн",
        "name_en": "Bahrain",
        "currency_en": "Bahraini Dinar",
        "currency_bg": "Бахрейнски динар",
        "currency_code": "BHD",
        "currency_code_bg": "БХД",
        "phone_code": "973"
    },
    {
        "code": "BG",
        "name_bg": "България",
        "name_en": "Bulgaria",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "359"
    },
    {
        "code": "BR",
        "name_bg": "Бразилия",
        "name_en": "Brazil",
        "currency_en": "Brazilian Real",
        "currency_bg": "Бразилски реал",
        "currency_code": "BRL",
        "currency_code_bg": "БРЛ",
        "phone_code": "55"
    },
    {
        "code": "CA",
        "name_bg": "Канада",
        "name_en": "Canada",
        "currency_en": "Canadian Dollar",
        "currency_bg": "Канадски долар",
        "currency_code": "CAD",
        "currency_code_bg": "КАД",
        "phone_code": "1"
    },
    {
        "code": "BD",
        "name_bg": "Бангладеш",
        "name_en": "Bangladesh",
        "currency_en": "Bangladeshi Taka",
        "currency_bg": "Бангладешка така",
        "currency_code": "BDT",
        "currency_code_bg": "БДТ",
        "phone_code": "880"
    },
    {
        "code": "BB",
        "name_bg": "Барбадос",
        "name_en": "Barbados",
        "currency_en": "Barbadian Dollar",
        "currency_bg": "Барбадоски долар",
        "currency_code": "BBD",
        "currency_code_bg": "ББД",
        "phone_code": "1246"
    },
    {
        "code": "BY",
        "name_bg": "Беларус",
        "name_en": "Belarus",
        "currency_en": "Belarusian Ruble",
        "currency_bg": "Беларуска рубла",
        "currency_code": "BYN",
        "currency_code_bg": "БЫН",
        "phone_code": "375"
    },
    {
        "code": "BE",
        "name_bg": "Белгия",
        "name_en": "Belgium",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "32"
    },
    {
        "code": "BZ",
        "name_bg": "Белиз",
        "name_en": "Belize",
        "currency_en": "Belize Dollar",
        "currency_bg": "Белизки долар",
        "currency_code": "BZD",
        "currency_code_bg": "БЗД",
        "phone_code": "501"
    },
    {
        "code": "BJ",
        "name_bg": "Бенин",
        "name_en": "Benin",
        "currency_en": "West African CFA franc",
        "currency_bg": "Западноафрикански CFA франк",
        "currency_code": "XOF",
        "currency_code_bg": "ХОФ",
        "phone_code": "229"
    },
    {
        "code": "BT",
        "name_bg": "Бутан",
        "name_en": "Bhutan",
        "currency_en": "Bhutanese Ngultrum",
        "currency_bg": "Бутански нгултрум",
        "currency_code": "BTN",
        "currency_code_bg": "БТН",
        "phone_code": "975"
    },
    {
        "code": "BO",
        "name_bg": "Боливия",
        "name_en": "Bolivia",
        "currency_en": "Bolivian Boliviano",
        "currency_bg": "Боливийски боливиано",
        "currency_code": "BOB",
        "currency_code_bg": "БОБ",
        "phone_code": "591"
    },
    {
        "code": "BA",
        "name_bg": "Босна и Херцеговина",
        "name_en": "Bosnia and Herzegovina",
        "currency_en": "Bosnia and Herzegovina Convertible Mark",
        "currency_bg": "Конвертируем марка на Босна и Херцеговина",
        "currency_code": "BAM",
        "currency_code_bg": "БАМ",
        "phone_code": "387"
    },
    {
        "code": "BW",
        "name_bg": "Ботсвана",
        "name_en": "Botswana",
        "currency_en": "Botswana Pula",
        "currency_bg": "Ботсванска пула",
        "currency_code": "BWP",
        "currency_code_bg": "БВП",
        "phone_code": "267"
    },
    {
        "code": "BN",
        "name_bg": "Бруней",
        "name_en": "Brunei",
        "currency_en": "Brunei Dollar",
        "currency_bg": "Брунейски долар",
        "currency_code": "BND",
        "currency_code_bg": "БНД",
        "phone_code": "673"
    },
    {
        "code": "BF",
        "name_bg": "Буркина Фасо",
        "name_en": "Burkina Faso",
        "currency_en": "West African CFA franc",
        "currency_bg": "Западноафрикански CFA франк",
        "currency_code": "XOF",
        "currency_code_bg": "ХОФ",
        "phone_code": "226"
    },
    {
        "code": "BI",
        "name_bg": "Бурунди",
        "name_en": "Burundi",
        "currency_en": "Burundian Franc",
        "currency_bg": "Бурундийски франк",
        "currency_code": "BIF",
        "currency_code_bg": "БИФ",
        "phone_code": "257"
    },
    {
        "code": "CV",
        "name_bg": "Кабо Верде",
        "name_en": "Cabo Verde",
        "currency_en": "Cape Verdean Escudo",
        "currency_bg": "Кабо Верде ескудо",
        "currency_code": "CVE",
        "currency_code_bg": "ЦВЕ",
        "phone_code": "238"
    },
    {
        "code": "KH",
        "name_bg": "Камбоджа",
        "name_en": "Cambodia",
        "currency_en": "Cambodian Riel",
        "currency_bg": "Камбоджански риел",
        "currency_code": "KHR",
        "currency_code_bg": "КХР",
        "phone_code": "855"
    },
    {
        "code": "CM",
        "name_bg": "Камерун",
        "name_en": "Cameroon",
        "currency_en": "Central African CFA franc",
        "currency_bg": "Централноафрикански CFA франк",
        "currency_code": "XAF",
        "currency_code_bg": "ХАФ",
        "phone_code": "237"
    },
    {
        "code": "CF",
        "name_bg": "Централноафриканска република",
        "name_en": "Central African Republic",
        "currency_en": "Central African CFA franc",
        "currency_bg": "Централноафрикански CFA франк",
        "currency_code": "XAF",
        "currency_code_bg": "ХАФ",
        "phone_code": "236"
    },
    {
        "code": "TD",
        "name_bg": "Чад",
        "name_en": "Chad",
        "currency_en": "Central African CFA franc",
        "currency_bg": "Централноафрикански CFA франк",
        "currency_code": "XAF",
        "currency_code_bg": "ХАФ",
        "phone_code": "235"
    },
    {
        "code": "CL",
        "name_bg": "Чили",
        "name_en": "Chile",
        "currency_en": "Chilean Peso",
        "currency_bg": "Чилийско песо",
        "currency_code": "CLP",
        "currency_code_bg": "ЧЛП",
        "phone_code": "56"
    },
    {
        "code": "CN",
        "name_bg": "Китай",
        "name_en": "China",
        "currency_en": "Renminbi (Yuan)",
        "currency_bg": "Китайски юан",
        "currency_code": "CNY",
        "currency_code_bg": "CNY",
        "phone_code": "86"
    },
    {
        "code": "CO",
        "name_bg": "Колумбия",
        "name_en": "Colombia",
        "currency_en": "Colombian Peso",
        "currency_bg": "Колумбийско песо",
        "currency_code": "COP",
        "currency_code_bg": "COP",
        "phone_code": "57"
    },
    {
        "code": "KM",
        "name_bg": "Комори",
        "name_en": "Comoros",
        "currency_en": "Comorian Franc",
        "currency_bg": "Коморски франк",
        "currency_code": "KMF",
        "currency_code_bg": "КМФ",
        "phone_code": "269"
    },
    {
        "code": "CG",
        "name_bg": "Конго",
        "name_en": "Congo",
        "currency_en": "Central African CFA franc",
        "currency_bg": "Централноафрикански CFA франк",
        "currency_code": "XAF",
        "currency_code_bg": "ХАФ",
        "phone_code": "242"
    },
    {
        "code": "CD",
        "name_bg": "Демократична република Конго",
        "name_en": "Congo, Democratic Republic",
        "currency_en": "Congolese Franc",
        "currency_bg": "Конголезки франк",
        "currency_code": "CDF",
        "currency_code_bg": "КДФ",
        "phone_code": "243"
    },
    {
        "code": "CR",
        "name_bg": "Коста Рика",
        "name_en": "Costa Rica",
        "currency_en": "Costa Rican Colón",
        "currency_bg": "Коста рикански колон",
        "currency_code": "CRC",
        "currency_code_bg": "CRC",
        "phone_code": "506"
    },
    {
        "code": "CI",
        "name_bg": "Кот д'Ивоар",
        "name_en": "Côte d'Ivoire",
        "currency_en": "West African CFA franc",
        "currency_bg": "Западноафрикански CFA франк",
        "currency_code": "XOF",
        "currency_code_bg": "ХОФ",
        "phone_code": "225"
    },
    {
        "code": "HR",
        "name_bg": "Хърватия",
        "name_en": "Croatia",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "385"
    },
    {
        "code": "CU",
        "name_bg": "Куба",
        "name_en": "Cuba",
        "currency_en": "Cuban Peso",
        "currency_bg": "Кубинско песо",
        "currency_code": "CUP",
        "currency_code_bg": "CUP",
        "phone_code": "53"
    },
    {
        "code": "CY",
        "name_bg": "Кипър",
        "name_en": "Cyprus",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "357"
    },
    {
        "code": "CZ",
        "name_bg": "Чехия",
        "name_en": "Czechia",
        "currency_en": "Czech Koruna",
        "currency_bg": "Чешка крона",
        "currency_code": "CZK",
        "currency_code_bg": "ЧЗК",
        "phone_code": "420"
    },
    {
        "code": "DK",
        "name_bg": "Дания",
        "name_en": "Denmark",
        "currency_en": "Danish Krone",
        "currency_bg": "Датска крона",
        "currency_code": "DKK",
        "currency_code_bg": "ДКК",
        "phone_code": "45"
    },
    {
        "code": "DJ",
        "name_bg": "Джибути",
        "name_en": "Djibouti",
        "currency_en": "Djiboutian Franc",
        "currency_bg": "Джибутски франк",
        "currency_code": "DJF",
        "currency_code_bg": "ДЖФ",
        "phone_code": "253"
    },
    {
        "code": "DM",
        "name_bg": "Доминика",
        "name_en": "Dominica",
        "currency_en": "East Caribbean Dollar",
        "currency_bg": "Източнокарибски долар",
        "currency_code": "XCD",
        "currency_code_bg": "ХКД",
        "phone_code": "1767"
    },
    {
        "code": "DO",
        "name_bg": "Доминиканска република",
        "name_en": "Dominican Republic",
        "currency_en": "Dominican Peso",
        "currency_bg": "Доминиканско песо",
        "currency_code": "DOP",
        "currency_code_bg": "DOP",
        "phone_code": "1809"
    },
    {
        "code": "EC",
        "name_bg": "Еквадор",
        "name_en": "Ecuador",
        "currency_en": "United States Dollar",
        "currency_bg": "Щатски долар",
        "currency_code": "USD",
        "currency_code_bg": "USD",
        "phone_code": "593"
    },
    {
        "code": "EG",
        "name_bg": "Египет",
        "name_en": "Egypt",
        "currency_en": "Egyptian Pound",
        "currency_bg": "Египетска лира",
        "currency_code": "EGP",
        "currency_code_bg": "EGP",
        "phone_code": "20"
    },
    {
        "code": "SV",
        "name_bg": "Ел Салвадор",
        "name_en": "El Salvador",
        "currency_en": "United States Dollar",
        "currency_bg": "Щатски долар",
        "currency_code": "USD",
        "currency_code_bg": "USD",
        "phone_code": "503"
    },
    {
        "code": "GQ",
        "name_bg": "Екваториална Гвинея",
        "name_en": "Equatorial Guinea",
        "currency_en": "Central African CFA franc",
        "currency_bg": "Централноафрикански CFA франк",
        "currency_code": "XAF",
        "currency_code_bg": "ХАФ",
        "phone_code": "240"
    },
    {
        "code": "ER",
        "name_bg": "Еритрея",
        "name_en": "Eritrea",
        "currency_en": "Eritrean Nakfa",
        "currency_bg": "Еритрейска накфа",
        "currency_code": "ERN",
        "currency_code_bg": "ERN",
        "phone_code": "291"
    },
    {
        "code": "EE",
        "name_bg": "Естония",
        "name_en": "Estonia",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "372"
    },
    {
        "code": "SZ",
        "name_bg": "Есватини",
        "name_en": "Eswatini",
        "currency_en": "Eswatini Lilangeni",
        "currency_bg": "Есватински лилангени",
        "currency_code": "SZL",
        "currency_code_bg": "SZL",
        "phone_code": "268"
    },
    {
        "code": "ET",
        "name_bg": "Етиопия",
        "name_en": "Ethiopia",
        "currency_en": "Ethiopian Birr",
        "currency_bg": "Етиопски бир",
        "currency_code": "ETB",
        "currency_code_bg": "ETB",
        "phone_code": "251"
    },
    {
        "code": "FJ",
        "name_bg": "Фиджи",
        "name_en": "Fiji",
        "currency_en": "Fijian Dollar",
        "currency_bg": "Фиджийски долар",
        "currency_code": "FJD",
        "currency_code_bg": "FJD",
        "phone_code": "679"
    },
    {
        "code": "FI",
        "name_bg": "Финландия",
        "name_en": "Finland",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "358"
    },
    {
        "code": "FR",
        "name_bg": "Франция",
        "name_en": "France",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "33"
    },
    {
        "code": "GA",
        "name_bg": "Габон",
        "name_en": "Gabon",
        "currency_en": "Central African CFA franc",
        "currency_bg": "Централноафрикански CFA франк",
        "currency_code": "XAF",
        "currency_code_bg": "ХАФ",
        "phone_code": "241"
    },
    {
        "code": "GM",
        "name_bg": "Гамбия",
        "name_en": "Gambia",
        "currency_en": "Gambian Dalasi",
        "currency_bg": "Гамбиецки даласи",
        "currency_code": "GMD",
        "currency_code_bg": "GMD",
        "phone_code": "220"
    },
    {
        "code": "GE",
        "name_bg": "Грузия",
        "name_en": "Georgia",
        "currency_en": "Georgian Lari",
        "currency_bg": "Грузински лари",
        "currency_code": "GEL",
        "currency_code_bg": "GEL",
        "phone_code": "995"
    },
    {
        "code": "DE",
        "name_bg": "Германия",
        "name_en": "Germany",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "49"
    },
    {
        "code": "GH",
        "name_bg": "Гана",
        "name_en": "Ghana",
        "currency_en": "Ghanaian Cedi",
        "currency_bg": "Гански седжи",
        "currency_code": "GHS",
        "currency_code_bg": "GHS",
        "phone_code": "233"
    },
    {
        "code": "GR",
        "name_bg": "Гърция",
        "name_en": "Greece",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "30"
    },
    {
        "code": "GD",
        "name_bg": "Гренада",
        "name_en": "Grenada",
        "currency_en": "East Caribbean Dollar",
        "currency_bg": "Източнокарибски долар",
        "currency_code": "XCD",
        "currency_code_bg": "XCD",
        "phone_code": "1473"
    },
    {
        "code": "GT",
        "name_bg": "Гватемала",
        "name_en": "Guatemala",
        "currency_en": "Guatemalan Quetzal",
        "currency_bg": "Гватемалски кетцал",
        "currency_code": "GTQ",
        "currency_code_bg": "GTQ",
        "phone_code": "502"
    },
    {
        "code": "GN",
        "name_bg": "Гвинея",
        "name_en": "Guinea",
        "currency_en": "Guinean Franc",
        "currency_bg": "Гвинейски франк",
        "currency_code": "GNF",
        "currency_code_bg": "GNF",
        "phone_code": "224"
    },
    {
        "code": "GW",
        "name_bg": "Гвинея-Бисау",
        "name_en": "Guinea-Bissau",
        "currency_en": "West African CFA franc",
        "currency_bg": "Западноафрикански CFA франк",
        "currency_code": "XOF",
        "currency_code_bg": "ХОФ",
        "phone_code": "245"
    },
    {
        "code": "GY",
        "name_bg": "Гаяна",
        "name_en": "Guyana",
        "currency_en": "Guyanese Dollar",
        "currency_bg": "Гаянски долар",
        "currency_code": "GYD",
        "currency_code_bg": "GYD",
        "phone_code": "592"
    },
    {
        "code": "HT",
        "name_bg": "Хаити",
        "name_en": "Haiti",
        "currency_en": "Haitian Gourde",
        "currency_bg": "Хаитски гурд",
        "currency_code": "HTG",
        "currency_code_bg": "HTG",
        "phone_code": "509"
    },
    {
        "code": "HN",
        "name_bg": "Хондурас",
        "name_en": "Honduras",
        "currency_en": "Honduran Lempira",
        "currency_bg": "Хондураски лемпира",
        "currency_code": "HNL",
        "currency_code_bg": "HNL",
        "phone_code": "504"
    },
    {
        "code": "HU",
        "name_bg": "Унгария",
        "name_en": "Hungary",
        "currency_en": "Hungarian Forint",
        "currency_bg": "Унгарски форинт",
        "currency_code": "HUF",
        "currency_code_bg": "HUF",
        "phone_code": "36"
    },
    {
        "code": "IS",
        "name_bg": "Исландия",
        "name_en": "Iceland",
        "currency_en": "Icelandic Króna",
        "currency_bg": "Исландска крона",
        "currency_code": "ISK",
        "currency_code_bg": "ISK",
        "phone_code": "354"
    },
    {
        "code": "IN",
        "name_bg": "Индия",
        "name_en": "India",
        "currency_en": "Indian Rupee",
        "currency_bg": "Индийска рупия",
        "currency_code": "INR",
        "currency_code_bg": "INR",
        "phone_code": "91"
    },
    {
        "code": "ID",
        "name_bg": "Индонезия",
        "name_en": "Indonesia",
        "currency_en": "Indonesian Rupiah",
        "currency_bg": "Индонезийска рупия",
        "currency_code": "IDR",
        "currency_code_bg": "IDR",
        "phone_code": "62"
    },
    {
        "code": "IR",
        "name_bg": "Иран",
        "name_en": "Iran",
        "currency_en": "Iranian Rial",
        "currency_bg": "Ирански риал",
        "currency_code": "IRR",
        "currency_code_bg": "IRR",
        "phone_code": "98"
    },
    {
        "code": "IQ",
        "name_bg": "Ирак",
        "name_en": "Iraq",
        "currency_en": "Iraqi Dinar",
        "currency_bg": "Иракски динар",
        "currency_code": "IQD",
        "currency_code_bg": "IQD",
        "phone_code": "964"
    },
    {
        "code": "IE",
        "name_bg": "Ирландия",
        "name_en": "Ireland",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "353"
    },
    {
        "code": "IL",
        "name_bg": "Израел",
        "name_en": "Israel",
        "currency_en": "Israeli New Shekel",
        "currency_bg": "Нов израелски шекел",
        "currency_code": "ILS",
        "currency_code_bg": "ILS",
        "phone_code": "972"
    },
    {
        "code": "IT",
        "name_bg": "Италия",
        "name_en": "Italy",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "39"
    },
    {
        "code": "JM",
        "name_bg": "Ямайка",
        "name_en": "Jamaica",
        "currency_en": "Jamaican Dollar",
        "currency_bg": "Ямайски долар",
        "currency_code": "JMD",
        "currency_code_bg": "JMD",
        "phone_code": "1876"
    },
    {
        "code": "JP",
        "name_bg": "Япония",
        "name_en": "Japan",
        "currency_en": "Japanese Yen",
        "currency_bg": "Японска йена",
        "currency_code": "JPY",
        "currency_code_bg": "JPY",
        "phone_code": "81"
    },
    {
        "code": "JO",
        "name_bg": "Йордания",
        "name_en": "Jordan",
        "currency_en": "Jordanian Dinar",
        "currency_bg": "Йордански динар",
        "currency_code": "JOD",
        "currency_code_bg": "JOD",
        "phone_code": "962"
    },
    {
        "code": "KZ",
        "name_bg": "Казахстан",
        "name_en": "Kazakhstan",
        "currency_en": "Kazakhstani Tenge",
        "currency_bg": "Казахстански тенге",
        "currency_code": "KZT",
        "currency_code_bg": "KZT",
        "phone_code": "7"
    },
    {
        "code": "KE",
        "name_bg": "Кения",
        "name_en": "Kenya",
        "currency_en": "Kenyan Shilling",
        "currency_bg": "Кенийски шилдинг",
        "currency_code": "KES",
        "currency_code_bg": "KES",
        "phone_code": "254"
    },
    {
        "code": "KI",
        "name_bg": "Кирибати",
        "name_en": "Kiribati",
        "currency_en": "Australian Dollar",
        "currency_bg": "Австралийски долар",
        "currency_code": "AUD",
        "currency_code_bg": "АУД",
        "phone_code": "686"
    },
    {
        "code": "XK",
        "name_bg": "Косово",
        "name_en": "Kosovo",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "383"
    },
    {
        "code": "KW",
        "name_bg": "Кувейт",
        "name_en": "Kuwait",
        "currency_en": "Kuwaiti Dinar",
        "currency_bg": "Кувейтски динар",
        "currency_code": "KWD",
        "currency_code_bg": "KWD",
        "phone_code": "965"
    },
    {
        "code": "KG",
        "name_bg": "Киргизстан",
        "name_en": "Kyrgyzstan",
        "currency_en": "Kyrgyzstani Som",
        "currency_bg": "Киргизки сом",
        "currency_code": "KGS",
        "currency_code_bg": "KGS",
        "phone_code": "996"
    },
    {
        "code": "LA",
        "name_bg": "Лаос",
        "name_en": "Laos",
        "currency_en": "Lao Kip",
        "currency_bg": "Лаоски кип",
        "currency_code": "LAK",
        "currency_code_bg": "LAK",
        "phone_code": "856"
    },
    {
        "code": "LV",
        "name_bg": "Латвия",
        "name_en": "Latvia",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "371"
    },
    {
        "code": "LB",
        "name_bg": "Ливан",
        "name_en": "Lebanon",
        "currency_en": "Lebanese Pound",
        "currency_bg": "Ливанска лира",
        "currency_code": "LBP",
        "currency_code_bg": "LBP",
        "phone_code": "961"
    },
    {
        "code": "LS",
        "name_bg": "Лесото",
        "name_en": "Lesotho",
        "currency_en": "Lesotho Loti",
        "currency_bg": "Лесотски лоти",
        "currency_code": "LSL",
        "currency_code_bg": "LSL",
        "phone_code": "266"
    },
    {
        "code": "LR",
        "name_bg": "Либерия",
        "name_en": "Liberia",
        "currency_en": "Liberian Dollar",
        "currency_bg": "Либерийски долар",
        "currency_code": "LRD",
        "currency_code_bg": "LRD",
        "phone_code": "231"
    },
    {
        "code": "LY",
        "name_bg": "Либия",
        "name_en": "Libya",
        "currency_en": "Libyan Dinar",
        "currency_bg": "Либийски динар",
        "currency_code": "LYD",
        "currency_code_bg": "LYD",
        "phone_code": "218"
    },
    {
        "code": "LI",
        "name_bg": "Лихтенщайн",
        "name_en": "Liechtenstein",
        "currency_en": "Swiss Franc",
        "currency_bg": "Швейцарски франк",
        "currency_code": "CHF",
        "currency_code_bg": "CHF",
        "phone_code": "423"
    },
    {
        "code": "LT",
        "name_bg": "Литва",
        "name_en": "Lithuania",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "370"
    },
    {
        "code": "LU",
        "name_bg": "Люксембург",
        "name_en": "Luxembourg",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "352"
    },
    {
        "code": "MG",
        "name_bg": "Мадагаскар",
        "name_en": "Madagascar",
        "currency_en": "Malagasy Ariary",
        "currency_bg": "Мадагаскарски ариари",
        "currency_code": "MGA",
        "currency_code_bg": "MGA",
        "phone_code": "261"
    },
    {
        "code": "MW",
        "name_bg": "Малави",
        "name_en": "Malawi",
        "currency_en": "Malawian Kwacha",
        "currency_bg": "Малавийска квача",
        "currency_code": "MWK",
        "currency_code_bg": "MWK",
        "phone_code": "265"
    },
    {
        "code": "MY",
        "name_bg": "Малайзия",
        "name_en": "Malaysia",
        "currency_en": "Malaysian Ringgit",
        "currency_bg": "Малайзийски ринггит",
        "currency_code": "MYR",
        "currency_code_bg": "MYR",
        "phone_code": "60"
    },
    {
        "code": "MV",
        "name_bg": "Малдиви",
        "name_en": "Maldives",
        "currency_en": "Maldivian Rufiyaa",
        "currency_bg": "Малдивска руфия",
        "currency_code": "MVR",
        "currency_code_bg": "MVR",
        "phone_code": "960"
    },
    {
        "code": "ML",
        "name_bg": "Мали",
        "name_en": "Mali",
        "currency_en": "West African CFA franc",
        "currency_bg": "Западноафрикански CFA франк",
        "currency_code": "XOF",
        "currency_code_bg": "ХОФ",
        "phone_code": "223"
    },
    {
        "code": "MT",
        "name_bg": "Малта",
        "name_en": "Malta",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "356"
    },
    {
        "code": "MH",
        "name_bg": "Маршалови острови",
        "name_en": "Marshall Islands",
        "currency_en": "United States Dollar",
        "currency_bg": "Щатски долар",
        "currency_code": "USD",
        "currency_code_bg": "USD",
        "phone_code": "692"
    },
    {
        "code": "MR",
        "name_bg": "Мавритания",
        "name_en": "Mauritania",
        "currency_en": "Mauritanian Ouguiya",
        "currency_bg": "Мавританска угия",
        "currency_code": "MRU",
        "currency_code_bg": "MRU",
        "phone_code": "222"
    },
    {
        "code": "MU",
        "name_bg": "Мавриций",
        "name_en": "Mauritius",
        "currency_en": "Mauritian Rupee",
        "currency_bg": "Маврицийска рупия",
        "currency_code": "MUR",
        "currency_code_bg": "MUR",
        "phone_code": "230"
    },
    {
        "code": "MX",
        "name_bg": "Мексико",
        "name_en": "Mexico",
        "currency_en": "Mexican Peso",
        "currency_bg": "Мексиканско песо",
        "currency_code": "MXN",
        "currency_code_bg": "MXN",
        "phone_code": "52"
    },
    {
        "code": "FM",
        "name_bg": "Микронезия",
        "name_en": "Micronesia",
        "currency_en": "United States Dollar",
        "currency_bg": "Щатски долар",
        "currency_code": "USD",
        "currency_code_bg": "USD",
        "phone_code": "691"
    },
    {
        "code": "MD",
        "name_bg": "Молдова",
        "name_en": "Moldova",
        "currency_en": "Moldovan Leu",
        "currency_bg": "Молдова лей",
        "currency_code": "MDL",
        "currency_code_bg": "MDL",
        "phone_code": "373"
    },
    {
        "code": "MC",
        "name_bg": "Монако",
        "name_en": "Monaco",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "377"
    },
    {
        "code": "MN",
        "name_bg": "Монголия",
        "name_en": "Mongolia",
        "currency_en": "Mongolian Tögrög",
        "currency_bg": "Монголски тогрог",
        "currency_code": "MNT",
        "currency_code_bg": "MNT",
        "phone_code": "976"
    },
    {
        "code": "ME",
        "name_bg": "Черна Гора",
        "name_en": "Montenegro",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "382"
    },
    {
        "code": "MA",
        "name_bg": "Мароко",
        "name_en": "Morocco",
        "currency_en": "Moroccan Dirham",
        "currency_bg": "Марокански дирхам",
        "currency_code": "MAD",
        "currency_code_bg": "MAD",
        "phone_code": "212"
    },
    {
        "code": "MZ",
        "name_bg": "Мозамбик",
        "name_en": "Mozambique",
        "currency_en": "Mozambican Metical",
        "currency_bg": "Мозамбикски метикал",
        "currency_code": "MZN",
        "currency_code_bg": "MZN",
        "phone_code": "258"
    },
    {
        "code": "MM",
        "name_bg": "Мянмар",
        "name_en": "Myanmar",
        "currency_en": "Myanmar Kyat",
        "currency_bg": "Мянмарски киат",
        "currency_code": "MMK",
        "currency_code_bg": "MMK",
        "phone_code": "95"
    },
    {
        "code": "NA",
        "name_bg": "Намибия",
        "name_en": "Namibia",
        "currency_en": "Namibian Dollar",
        "currency_bg": "Намибийски долар",
        "currency_code": "NAD",
        "currency_code_bg": "NAD",
        "phone_code": "264"
    },
    {
        "code": "NR",
        "name_bg": "Науру",
        "name_en": "Nauru",
        "currency_en": "Australian Dollar",
        "currency_bg": "Австралийски долар",
        "currency_code": "AUD",
        "currency_code_bg": "AUD",
        "phone_code": "674"
    },
    {
        "code": "NP",
        "name_bg": "Непал",
        "name_en": "Nepal",
        "currency_en": "Nepalese Rupee",
        "currency_bg": "Непалска рупия",
        "currency_code": "NPR",
        "currency_code_bg": "NPR",
        "phone_code": "977"
    },
    {
        "code": "NL",
        "name_bg": "Нидерландия",
        "name_en": "Netherlands",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "31"
    },
    {
        "code": "NZ",
        "name_bg": "Нова Зеландия",
        "name_en": "New Zealand",
        "currency_en": "New Zealand Dollar",
        "currency_bg": "Новозеландски долар",
        "currency_code": "NZD",
        "currency_code_bg": "NZD",
        "phone_code": "64"
    },
    {
        "code": "NI",
        "name_bg": "Никарагуа",
        "name_en": "Nicaragua",
        "currency_en": "Nicaraguan Córdoba",
        "currency_bg": "Никарагуански кордоба",
        "currency_code": "NIO",
        "currency_code_bg": "NIO",
        "phone_code": "505"
    },
    {
        "code": "NE",
        "name_bg": "Нигер",
        "name_en": "Niger",
        "currency_en": "West African CFA franc",
        "currency_bg": "Западноафрикански CFA франк",
        "currency_code": "XOF",
        "currency_code_bg": "XOF",
        "phone_code": "227"
    },
    {
        "code": "NG",
        "name_bg": "Нигерия",
        "name_en": "Nigeria",
        "currency_en": "Nigerian Naira",
        "currency_bg": "Нигерийска найра",
        "currency_code": "NGN",
        "currency_code_bg": "NGN",
        "phone_code": "234"
    },
    {
        "code": "KP",
        "name_bg": "Северна Корея",
        "name_en": "North Korea",
        "currency_en": "North Korean Won",
        "currency_bg": "Северокорейски вон",
        "currency_code": "KPW",
        "currency_code_bg": "KPW",
        "phone_code": "850"
    },
    {
        "code": "MK",
        "name_bg": "Северна Македония",
        "name_en": "North Macedonia",
        "currency_en": "Macedonian Denar",
        "currency_bg": "Македонски денар",
        "currency_code": "MKD",
        "currency_code_bg": "MKD",
        "phone_code": "389"
    },
    {
        "code": "NO",
        "name_bg": "Норвегия",
        "name_en": "Norway",
        "currency_en": "Norwegian Krone",
        "currency_bg": "Норвежка крона",
        "currency_code": "NOK",
        "currency_code_bg": "NOK",
        "phone_code": "47"
    },
    {
        "code": "OM",
        "name_bg": "Оман",
        "name_en": "Oman",
        "currency_en": "Omani Rial",
        "currency_bg": "Омански риал",
        "currency_code": "OMR",
        "currency_code_bg": "OMР",
        "phone_code": "968"
    },
    {
        "code": "PK",
        "name_bg": "Пакистан",
        "name_en": "Pakistan",
        "currency_en": "Pakistani Rupee",
        "currency_bg": "Пакистанска рупия",
        "currency_code": "PKR",
        "currency_code_bg": "PKR",
        "phone_code": "92"
    },
    {
        "code": "PW",
        "name_bg": "Палау",
        "name_en": "Palau",
        "currency_en": "United States Dollar",
        "currency_bg": "Щатски долар",
        "currency_code": "USD",
        "currency_code_bg": "USD",
        "phone_code": "680"
    },
    {
        "code": "PS",
        "name_bg": "Палестина",
        "name_en": "Palestine",
        "currency_en": "Israeli New Shekel",
        "currency_bg": "Нов израелски шекел",
        "currency_code": "ILS",
        "currency_code_bg": "ILS",
        "phone_code": "970"
    },
    {
        "code": "PA",
        "name_bg": "Панама",
        "name_en": "Panama",
        "currency_en": "Panamanian Balboa",
        "currency_bg": "Панамски балбоа",
        "currency_code": "PAB",
        "currency_code_bg": "PAB",
        "phone_code": "507"
    },
    {
        "code": "PG",
        "name_bg": "Папуа Нова Гвинея",
        "name_en": "Papua New Guinea",
        "currency_en": "Papua New Guinean Kina",
        "currency_bg": "Папуа новогвинейска кина",
        "currency_code": "PGK",
        "currency_code_bg": "PGK",
        "phone_code": "675"
    },
    {
        "code": "PY",
        "name_bg": "Парагвай",
        "name_en": "Paraguay",
        "currency_en": "Paraguayan Guaraní",
        "currency_bg": "Парагвайски гуарани",
        "currency_code": "PYG",
        "currency_code_bg": "PYG",
        "phone_code": "595"
    },
    {
        "code": "PE",
        "name_bg": "Перу",
        "name_en": "Peru",
        "currency_en": "Peruvian Sol",
        "currency_bg": "Перуански сол",
        "currency_code": "PEN",
        "currency_code_bg": "PEN",
        "phone_code": "51"
    },
    {
        "code": "PH",
        "name_bg": "Филипини",
        "name_en": "Philippines",
        "currency_en": "Philippine Peso",
        "currency_bg": "Филипинско песо",
        "currency_code": "PHP",
        "currency_code_bg": "PHP",
        "phone_code": "63"
    },
    {
        "code": "PL",
        "name_bg": "Полша",
        "name_en": "Poland",
        "currency_en": "Polish Złoty",
        "currency_bg": "Полска злота",
        "currency_code": "PLN",
        "currency_code_bg": "PLN",
        "phone_code": "48"
    },
    {
        "code": "PT",
        "name_bg": "Португалия",
        "name_en": "Portugal",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "ЕВР",
        "phone_code": "351"
    },
    {
        "code": "QA",
        "name_bg": "Катар",
        "name_en": "Qatar",
        "currency_en": "Qatari Riyal",
        "currency_bg": "Катарски риал",
        "currency_code": "QAR",
        "currency_code_bg": "QAR",
        "phone_code": "974"
    },
    {
        "code": "RO",
        "name_bg": "Румъния",
        "name_en": "Romania",
        "currency_en": "Romanian Leu",
        "currency_bg": "Румънски лей",
        "currency_code": "RON",
        "currency_code_bg": "RON",
        "phone_code": "40"
    },
    {
        "code": "RU",
        "name_bg": "Русия",
        "name_en": "Russia",
        "currency_en": "Russian Ruble",
        "currency_bg": "Руска рубла",
        "currency_code": "RUB",
        "currency_code_bg": "RUB",
        "phone_code": "7"
    },
    {
        "code": "RW",
        "name_bg": "Руанда",
        "name_en": "Rwanda",
        "currency_en": "Rwandan Franc",
        "currency_bg": "Руандийски франк",
        "currency_code": "RWF",
        "currency_code_bg": "RWF",
        "phone_code": "250"
    },
    {
        "code": "KN",
        "name_bg": "Сейнт Китс и Невис",
        "name_en": "Saint Kitts and Nevis",
        "currency_en": "East Caribbean Dollar",
        "currency_bg": "Източнокарибски долар",
        "currency_code": "XCD",
        "currency_code_bg": "XCD",
        "phone_code": "1869"
    },
    {
        "code": "LC",
        "name_bg": "Сейнт Лусия",
        "name_en": "Saint Lucia",
        "currency_en": "East Caribbean Dollar",
        "currency_bg": "Източнокарибски долар",
        "currency_code": "XCD",
        "currency_code_bg": "XCD",
        "phone_code": "1758"
    },
    {
        "code": "VC",
        "name_bg": "Сейнт Винсент и Гренадини",
        "name_en": "Saint Vincent and the Grenadines",
        "currency_en": "East Caribbean Dollar",
        "currency_bg": "Източнокарибски долар",
        "currency_code": "XCD",
        "currency_code_bg": "XCD",
        "phone_code": "1784"
    },
    {
        "code": "WS",
        "name_bg": "Самоа",
        "name_en": "Samoa",
        "currency_en": "Samoan Tala",
        "currency_bg": "Самоанска тала",
        "currency_code": "WST",
        "currency_code_bg": "WST",
        "phone_code": "685"
    },
    {
        "code": "SM",
        "name_bg": "Сан Марино",
        "name_en": "San Marino",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "EUR",
        "phone_code": "378"
    },
    {
        "code": "ST",
        "name_bg": "Сао Томе и Принсипи",
        "name_en": "Sao Tome and Principe",
        "currency_en": "Sao Tome and Principe Dobra",
        "currency_bg": "Добра на Сао Томе и Принсипи",
        "currency_code": "STN",
        "currency_code_bg": "STN",
        "phone_code": "239"
    },
    {
        "code": "SA",
        "name_bg": "Саудитска Арабия",
        "name_en": "Saudi Arabia",
        "currency_en": "Saudi Riyal",
        "currency_bg": "Саудитски риал",
        "currency_code": "SAR",
        "currency_code_bg": "SAR",
        "phone_code": "966"
    },
    {
        "code": "SN",
        "name_bg": "Сенегал",
        "name_en": "Senegal",
        "currency_en": "West African CFA franc",
        "currency_bg": "Западноафрикански CFA франк",
        "currency_code": "XOF",
        "currency_code_bg": "XOF",
        "phone_code": "221"
    },
    {
        "code": "RS",
        "name_bg": "Сърбия",
        "name_en": "Serbia",
        "currency_en": "Serbian Dinar",
        "currency_bg": "Сръбски динар",
        "currency_code": "RSD",
        "currency_code_bg": "RSD",
        "phone_code": "381"
    },
    {
        "code": "SC",
        "name_bg": "Сейшели",
        "name_en": "Seychelles",
        "currency_en": "Seychellois Rupee",
        "currency_bg": "Сейшелска рупия",
        "currency_code": "SCR",
        "currency_code_bg": "SCR",
        "phone_code": "248"
    },
    {
        "code": "SL",
        "name_bg": "Сиера Леоне",
        "name_en": "Sierra Leone",
        "currency_en": "Sierra Leonean Leone",
        "currency_bg": "Сиера леонски леоне",
        "currency_code": "SLL",
        "currency_code_bg": "SLL",
        "phone_code": "232"
    },
    {
        "code": "SG",
        "name_bg": "Сингапур",
        "name_en": "Singapore",
        "currency_en": "Singapore Dollar",
        "currency_bg": "Сингапурски долар",
        "currency_code": "SGD",
        "currency_code_bg": "SGD",
        "phone_code": "65"
    },
    {
        "code": "SK",
        "name_bg": "Словакия",
        "name_en": "Slovakia",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "EUR",
        "phone_code": "421"
    },
    {
        "code": "SI",
        "name_bg": "Словения",
        "name_en": "Slovenia",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "EUR",
        "phone_code": "386"
    },
    {
        "code": "SB",
        "name_bg": "Соломонови острови",
        "name_en": "Solomon Islands",
        "currency_en": "Solomon Islands Dollar",
        "currency_bg": "Соломонов долар",
        "currency_code": "SBD",
        "currency_code_bg": "SBD",
        "phone_code": "677"
    },
    {
        "code": "SO",
        "name_bg": "Сомалия",
        "name_en": "Somalia",
        "currency_en": "Somali Shilling",
        "currency_bg": "Сомалийски шилдинг",
        "currency_code": "SOS",
        "currency_code_bg": "SOS",
        "phone_code": "252"
    },
    {
        "code": "ZA",
        "name_bg": "Южна Африка",
        "name_en": "South Africa",
        "currency_en": "South African Rand",
        "currency_bg": "Южноафрикански ранд",
        "currency_code": "ZAR",
        "currency_code_bg": "ZAR",
        "phone_code": "27"
    },
    {
        "code": "KR",
        "name_bg": "Южна Корея",
        "name_en": "South Korea",
        "currency_en": "South Korean Won",
        "currency_bg": "Южнокорейски вон",
        "currency_code": "KRW",
        "currency_code_bg": "KRW",
        "phone_code": "82"
    },
    {
        "code": "SS",
        "name_bg": "Южен Судан",
        "name_en": "South Sudan",
        "currency_en": "South Sudanese Pound",
        "currency_bg": "Южносуданска лира",
        "currency_code": "SSP",
        "currency_code_bg": "SSP",
        "phone_code": "211"
    },
    {
        "code": "ES",
        "name_bg": "Испания",
        "name_en": "Spain",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "EUR",
        "phone_code": "34"
    },
    {
        "code": "LK",
        "name_bg": "Шри Ланка",
        "name_en": "Sri Lanka",
        "currency_en": "Sri Lankan Rupee",
        "currency_bg": "Шри ланкийска рупия",
        "currency_code": "LKR",
        "currency_code_bg": "LKR",
        "phone_code": "94"
    },
    {
        "code": "SD",
        "name_bg": "Судан",
        "name_en": "Sudan",
        "currency_en": "Sudanese Pound",
        "currency_bg": "Суданска лира",
        "currency_code": "SDG",
        "currency_code_bg": "SDG",
        "phone_code": "249"
    },
    {
        "code": "SR",
        "name_bg": "Суринам",
        "name_en": "Suriname",
        "currency_en": "Surinamese Dollar",
        "currency_bg": "Суринамен долар",
        "currency_code": "SRD",
        "currency_code_bg": "SRD",
        "phone_code": "597"
    },
    {
        "code": "SE",
        "name_bg": "Швеция",
        "name_en": "Sweden",
        "currency_en": "Swedish Krona",
        "currency_bg": "Шведска крона",
        "currency_code": "SEK",
        "currency_code_bg": "SEK",
        "phone_code": "46"
    },
    {
        "code": "CH",
        "name_bg": "Швейцария",
        "name_en": "Switzerland",
        "currency_en": "Swiss Franc",
        "currency_bg": "Швейцарски франк",
        "currency_code": "CHF",
        "currency_code_bg": "CHF",
        "phone_code": "41"
    },
    {
        "code": "SY",
        "name_bg": "Сирия",
        "name_en": "Syria",
        "currency_en": "Syrian Pound",
        "currency_bg": "Сирийска лира",
        "currency_code": "SYP",
        "currency_code_bg": "SYP",
        "phone_code": "963"
    },
    {
        "code": "TW",
        "name_bg": "Тайван",
        "name_en": "Taiwan",
        "currency_en": "New Taiwan Dollar",
        "currency_bg": "Нов тайвански долар",
        "currency_code": "TWD",
        "currency_code_bg": "TWD",
        "phone_code": "886"
    },
    {
        "code": "TJ",
        "name_bg": "Таджикистан",
        "name_en": "Tajikistan",
        "currency_en": "Tajikistani Somoni",
        "currency_bg": "Таджикски сомони",
        "currency_code": "TJS",
        "currency_code_bg": "TJS",
        "phone_code": "992"
    },
    {
        "code": "TZ",
        "name_bg": "Танзания",
        "name_en": "Tanzania",
        "currency_en": "Tanzanian Shilling",
        "currency_bg": "Танзанийски шилдинг",
        "currency_code": "TZS",
        "currency_code_bg": "TZS",
        "phone_code": "255"
    },
    {
        "code": "TH",
        "name_bg": "Таиланд",
        "name_en": "Thailand",
        "currency_en": "Thai Baht",
        "currency_bg": "Тайландски бат",
        "currency_code": "THB",
        "currency_code_bg": "THB",
        "phone_code": "66"
    },
    {
        "code": "TL",
        "name_bg": "Източен Тимор",
        "name_en": "Timor-Leste",
        "currency_en": "United States Dollar",
        "currency_bg": "Щатски долар",
        "currency_code": "USD",
        "currency_code_bg": "USD",
        "phone_code": "670"
    },
    {
        "code": "TG",
        "name_bg": "Того",
        "name_en": "Togo",
        "currency_en": "West African CFA franc",
        "currency_bg": "Западноафрикански CFA франк",
        "currency_code": "XOF",
        "currency_code_bg": "XOF",
        "phone_code": "228"
    },
    {
        "code": "TO",
        "name_bg": "Тонга",
        "name_en": "Tonga",
        "currency_en": "Tongan Paʻanga",
        "currency_bg": "Тонганска паанга",
        "currency_code": "TOP",
        "currency_code_bg": "TOP",
        "phone_code": "676"
    },
    {
        "code": "TT",
        "name_bg": "Тринидад и Тобаго",
        "name_en": "Trinidad and Tobago",
        "currency_en": "Trinidad and Tobago Dollar",
        "currency_bg": "Долар на Тринидад и Тобаго",
        "currency_code": "TTD",
        "currency_code_bg": "TTD",
        "phone_code": "1868"
    },
    {
        "code": "TN",
        "name_bg": "Тунис",
        "name_en": "Tunisia",
        "currency_en": "Tunisian Dinar",
        "currency_bg": "Тунизийски динар",
        "currency_code": "TND",
        "currency_code_bg": "TND",
        "phone_code": "216"
    },
    {
        "code": "TR",
        "name_bg": "Турция",
        "name_en": "Turkey",
        "currency_en": "Turkish Lira",
        "currency_bg": "Турска лира",
        "currency_code": "TRY",
        "currency_code_bg": "TRY",
        "phone_code": "90"
    },
    {
        "code": "TM",
        "name_bg": "Туркменистан",
        "name_en": "Turkmenistan",
        "currency_en": "Turkmenistani Manat",
        "currency_bg": "Туркменски манат",
        "currency_code": "TMT",
        "currency_code_bg": "TMT",
        "phone_code": "993"
    },
    {
        "code": "TV",
        "name_bg": "Тувалу",
        "name_en": "Tuvalu",
        "currency_en": "Australian Dollar",
        "currency_bg": "Австралийски долар",
        "currency_code": "AUD",
        "currency_code_bg": "AUD",
        "phone_code": "688"
    },
    {
        "code": "UG",
        "name_bg": "Уганда",
        "name_en": "Uganda",
        "currency_en": "Ugandan Shilling",
        "currency_bg": "Угандийски шилдинг",
        "currency_code": "UGX",
        "currency_code_bg": "UGX",
        "phone_code": "256"
    },
    {
        "code": "UA",
        "name_bg": "Украйна",
        "name_en": "Ukraine",
        "currency_en": "Ukrainian Hryvnia",
        "currency_bg": "Украинска хривня",
        "currency_code": "UAH",
        "currency_code_bg": "UAH",
        "phone_code": "380"
    },
    {
        "code": "AE",
        "name_bg": "ОАЕ",
        "name_en": "United Arab Emirates",
        "currency_en": "United Arab Emirates Dirham",
        "currency_bg": "Дирхам на ОАЕ",
        "currency_code": "AED",
        "currency_code_bg": "AED",
        "phone_code": "971"
    },
    {
        "code": "GB",
        "name_bg": "Обединено кралство",
        "name_en": "United Kingdom",
        "currency_en": "British Pound",
        "currency_bg": "Британска лира",
        "currency_code": "GBP",
        "currency_code_bg": "GBP",
        "phone_code": "44"
    },
    {
        "code": "US",
        "name_bg": "САЩ",
        "name_en": "United States",
        "currency_en": "United States Dollar",
        "currency_bg": "Щатски долар",
        "currency_code": "USD",
        "currency_code_bg": "USD",
        "phone_code": "1"
    },
    {
        "code": "UY",
        "name_bg": "Уругвай",
        "name_en": "Uruguay",
        "currency_en": "Uruguayan Peso",
        "currency_bg": "Уругвайско песо",
        "currency_code": "UYU",
        "currency_code_bg": "UYU",
        "phone_code": "598"
    },
    {
        "code": "UZ",
        "name_bg": "Узбекистан",
        "name_en": "Uzbekistan",
        "currency_en": "Uzbekistani Som",
        "currency_bg": "Узбекистански сум",
        "currency_code": "UZS",
        "currency_code_bg": "UZS",
        "phone_code": "998"
    },
    {
        "code": "VU",
        "name_bg": "Вануату",
        "name_en": "Vanuatu",
        "currency_en": "Vanuatu Vatu",
        "currency_bg": "Вануатски вату",
        "currency_code": "VUV",
        "currency_code_bg": "VUV",
        "phone_code": "678"
    },
    {
        "code": "VA",
        "name_bg": "Ватикан",
        "name_en": "Vatican City",
        "currency_en": "Euro",
        "currency_bg": "Евро",
        "currency_code": "EUR",
        "currency_code_bg": "EUR",
        "phone_code": "3906"
    },
    {
        "code": "VE",
        "name_bg": "Венецуела",
        "name_en": "Venezuela",
        "currency_en": "Venezuelan Bolívar",
        "currency_bg": "Венецуелски боливар",
        "currency_code": "VES",
        "currency_code_bg": "VES",
        "phone_code": "58"
    },
    {
        "code": "VN",
        "name_bg": "Виетнам",
        "name_en": "Vietnam",
        "currency_en": "Vietnamese Đồng",
        "currency_bg": "Виетнамски донг",
        "currency_code": "VND",
        "currency_code_bg": "VND",
        "phone_code": "84"
    },
    {
        "code": "YE",
        "name_bg": "Йемен",
        "name_en": "Yemen",
        "currency_en": "Yemeni Rial",
        "currency_bg": "Йеменски риал",
        "currency_code": "YER",
        "currency_code_bg": "YER",
        "phone_code": "967"
    },
    {
        "code": "ZM",
        "name_bg": "Замбия",
        "name_en": "Zambia",
        "currency_en": "Zambian Kwacha",
        "currency_bg": "Замбийска квача",
        "currency_code": "ZMW",
        "currency_code_bg": "ZMW",
        "phone_code": "260"
    },
    {
        "code": "ZW",
        "name_bg": "Зимбабве",
        "name_en": "Zimbabwe",
        "currency_en": "Zimbabwean Dollar",
        "currency_bg": "Зимбабвийски долар",
        "currency_code": "ZWL",
        "currency_code_bg": "ZWL",
        "phone_code": "263"
    }
];

// Helper functions for accessing country data
export const getCurrencies = () => {
    const countryMap = {};
    allCountries.forEach(country => {
        countryMap[country.currency_code] = {
            key: country.currency_code,
            value: country.currency_code,
            labelBg: country.currency_bg,
            labelEn: country.currency_en
        };
    });
    return Object.values(countryMap);
};

export const getCurrencyByCountry = (countryCode) =>
    allCountries.find(({ code }) => code === countryCode)?.currency_code ?? null;

export const getCountry = (code) =>
    allCountries.find(country => country.code === code);

export const getPhoneCodeByCountry = (countryCode) =>
    allCountries.find(({ code }) => code === countryCode)?.phone_code ?? null;
